import { Type } from "../Type";
export function string(condition, descriptor) {
    return new IslyString(condition, descriptor);
}
export class IslyString extends Type {
    stringCondition;
    descriptor;
    class = "string";
    conditionObject;
    constructor(stringCondition, descriptor) {
        super(typeof stringCondition == "string" ? `"${stringCondition}"` : "string", descriptor
            ? descriptor
            : () => {
                const conditionObject = this.getConditionObject();
                return conditionObject instanceof RegExp
                    ? `/${conditionObject.source}/${conditionObject.flags}`
                    : conditionObject instanceof Function
                        ? "custom-predicate"
                        : globalThis.Object.keys(conditionObject)
                            .map(key => `"${key}"`)
                            .join(" | ");
            });
        this.stringCondition = stringCondition;
        this.descriptor = descriptor;
    }
    is = (value) => {
        const conditionObject = this.getConditionObject();
        return (typeof value == "string" &&
            (conditionObject instanceof RegExp
                ? conditionObject.test(value)
                : conditionObject instanceof Function
                    ? conditionObject(value)
                    : typeof conditionObject == "object"
                        ? value in conditionObject
                        : conditionObject));
    };
    getConditionObject() {
        return (this.conditionObject ??= Array.isArray(this.stringCondition)
            ? this.stringCondition.reduce((result, current) => {
                result[current] = true;
                return result;
            }, globalThis.Object.create(null))
            : typeof this.stringCondition == "string"
                ? { [this.stringCondition]: true }
                : typeof this.stringCondition == "function"
                    ? this.stringCondition
                    : typeof this.stringCondition == "object"
                        ? this.stringCondition
                        : true);
    }
}
//# sourceMappingURL=index.js.map